// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Ri","categoryName":"Si","categoryImage":"Ti","categoryContent":"Ui","bottomAligned":"Vi"};